(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-voyage-omra]').forEach(root => {
    if (root.dataset.voyageReady) return; root.dataset.voyageReady = 'true';
    const destination = root.querySelector('[data-voyage-destination]');
    root.querySelectorAll('[data-voyage-preset]').forEach(link => link.addEventListener('click', () => {
      if (!destination) return;
      destination.value = link.dataset.voyagePreset;
      destination.dispatchEvent(new Event('change',{bubbles:true}));
      const flow = destination.closest('[data-ux-journey]')?.ctoJourney;
      if (flow) flow.show(1); else destination.focus({preventScroll:true});
    }));
  });
  init(); document.addEventListener('shopify:section:load',event => init(event.target));
})();
